module.exports = __webpack_public_path__ + "img/c63.4bec60aa.png";